// import React, { Component } from "react";
import { Popover } from "antd";
import BasePage from "../../base/BasePage";
import MainPagePresenter from "../../pages/main/MainPagePresenter";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import withRouter from "../../withRouter";
import NavBarSearch from "./NavBarSearch";
import "./nav.css";
import Notification from "../notification/Notification";
import { findObjectUseCase } from "../../usecases/object";

const defaultProps = {
  navigateIcon: "bi bi-list",
};

class NavBar extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      signOutUseCase(),
      getCurrentUserUseCase(),
    );
    this.state = {
      isBellClicked: false,
      isUserClicked: false,
      employeeName: [],
    };
  }
  async componentDidMount() {
    const employee = await findObjectUseCase().execute("employees", {
      keys: ["Firstname", "Middlename", "surname", "picture"],
    });

    const items = [];
    const CHUNK_SIZE = 800; // Adjust based on your needs

    // Process employees in chunks
    for (let i = 0; i < employee.length; i += CHUNK_SIZE) {
      const chunk = employee.slice(i, i + CHUNK_SIZE);

      chunk.forEach((item) => {
        const firstName = item.Firstname;
        const middleName = item.Middlename || "";
        const lastName = item.surname;
        const employeeName = `${firstName} ${middleName} ${lastName}`;
        items.push({ employeeName, id: item.id, profile: item.picture });
      });

      // Optional: Update state progressively to show loading progress
      this.setState({ employeeName: [...items] });

      // Optional: Small delay to prevent blocking UI
      await new Promise((resolve) => setTimeout(resolve, 0));
    }

    // Final state update
    this.setState({ employeeName: items });
  }

  onCLickSignOut() {
    this.presenter.onClickSignOut();
  }

  SearchSubmit(where) {
    this.navigateTo(`/profile/${where}`);
  }

  render() {
    const { className, onClickNavigate, navigateIcon, logo, title, action } =
      this.props;

    const user = this.getCurrentUser();
    const isMobile = this.isMobile();
    const currentRoles = this.getCurrentRoles();
    const isSuperAdmin = currentRoles.some((item) => item.id === "Super Admin");

    // const handleBellOnClick = () => {
    //   this.setState((prevState) => ({
    //     isBellClicked: !prevState.isBellClicked,
    //     isClicked: false,
    //     isUserClicked: false,
    //   }));
    // };

    const content = (
      <div className="d-grid">
        <button
          className="w-auto h-auto border-0 bg-transparent hover pt-2 pb-2 ps-5 pe-5"
          onClick={() => this.navigateTo("/profile")}
        >
          My Profile
        </button>
        <button
          className="w-auto h-auto border-0 bg-transparent hover p-2"
          onClick={() => this.navigateTo("/settings")}
        >
          My Settings
        </button>
        <button
          className="w-auto h-auto border-0 bg-transparent hover p-2"
          onClick={this.onCLickSignOut.bind(this)}
        >
          Logout
        </button>
      </div>
    );

    const isMobileContent = (
      <div className="d-flex row align-items-center justify-content-center h-100">
        <Popover content={content} trigger="click">
          <button
            style={{
              border: "0",
              backgroundColor: "white",
            }}
          >
            <div className="bg-primary text-white d-flex align-items-center justify-content-center w-100 h-100 p-1 rounded">
              {user.username.substring(0, 2).toUpperCase()}
            </div>
          </button>
        </Popover>

        <button
          // onClick={handleBellOnClick}
          style={{ border: "0", backgroundColor: "white" }}
        >
          <i style={{ zoom: "1.3" }} className="bi bi-bell" />
        </button>

        {/* <button
          onClick={() => console.warn("CLICKED")}
          style={{ border: "0", backgroundColor: "white" }}
        >
          <i style={{ zoom: "1.3" }} className="bi bi-lock" />
        </button> */}
      </div>
    );

    return (
      <>
        <nav
          className={`navbar navbar-expand-lg navbar-light shadow-sm ${className}`}
          style={{
            zoom: "1.1",
            width: "100%",
            position: "fixed",
            top: 0,
            height: "auto",
            zIndex: 1000,
          }}
        >
          <div className="container-fluid">
            <button
              onClick={onClickNavigate}
              type="button"
              className="btn btn-sm btn-link fs-4 ps-0 text-dark"
            >
              <i className={navigateIcon}></i>
            </button>
            <div className="d-flex align-items-center">
              {logo && (
                <img
                  className="w-auto"
                  src={logo}
                  height="40"
                  alt="title-logo"
                />
              )}
              {title && <h6 className="fw-bold m-0 fs-5">{title}</h6>}
            </div>
            {(action && action()) || <div />}

            <div
              style={{
                display: "flex",
                right: 0,
                position: "fixed",
                width: "60%",
                height: "2rem",
                marginRight: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  gap: "2rem",
                  width: "100%",
                }}
              >
                {isMobile ? (
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                    }}
                  >
                    <Popover content={isMobileContent} trigger="hover">
                      <button
                        // onClick={handleMobileView}
                        className="bg-transparent border-0"
                      >
                        <i className="bi bi-grid"></i>
                      </button>
                    </Popover>
                  </div>
                ) : (
                  <div className="d-flex gap-4 w-100 justify-content-end">
                    {/* search  */}
                    {isSuperAdmin && (
                      <div className="w-50">
                        <NavBarSearch
                          className="my-search"
                          onSubmit={this.SearchSubmit.bind(this)}
                          dropdownOptions={this.state.employeeName}
                        />
                      </div>
                    )}
                    {/* notification  */}
                    <Notification />
                    {/* <div className="tooltip-container">
                      <button
                        onClick={() => console.warn("CLICKED")}
                        style={{ border: "0", backgroundColor: "white" }}
                      >
                        <i style={{ zoom: "1.3" }} className="bi bi-lock" />
                      </button>
                      <div className="tooltip-content">Lock Screen</div>
                    </div> */}

                    <div className="tooltip-container">
                      <Popover content={content} trigger="click">
                        <button
                          // onClick={handleUserClick}
                          style={{ border: "0", backgroundColor: "white" }}
                        >
                          <div className="bg-primary text-white d-flex align-items-center justify-content-center w-100 h-100 p-1 rounded">
                            {user.username.substring(0, 2).toUpperCase()}
                          </div>
                        </button>
                      </Popover>
                      <div className="tooltip-content">{user.username}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>

        {/* bell  */}
        {/* {this.state.isBellClicked && (
          <div
            style={{
              width: isMobile ? "90%" : "20rem",
              height: "20vh",
              position: "fixed",
              marginTop: isMobile ? "15%" : "5rem",
              right: isMobile ? "5%" : 10,
              zIndex: 1001,
            }}
          >
            <CardView style={{ padding: 0 }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  padding: "5px 20px",
                }}
              >
                <button
                  className="text-primary bg-transparent border-0 fs-6"
                  style={{
                    marginTop: "auto",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  View more
                </button>
              </div>
            </CardView>
          </div>
        )} */}
      </>
    );
  }
}

NavBar.defaultProps = defaultProps;
export default withRouter(NavBar);
